import pagination from "../static/pagination";
import paginationMessage from "../static/paginationMessage";
import paginationTemplate from "../static/paginationTemplate";
import payloadCreateBlast from "../static/payloadCreateBlast";
import totalCustomer from "@/modules/wa-blast/store/state";

const mutations = {
	setResponse: (state, payload) => {
		state.response = payload;
	},
	setFetching: (state, payload) => {
		state.isFetching = payload;
	},
	setLoadMore: (state, payload) => {
		state.isLoadMore = payload;
	},
	setEndItemofPage: (state, payload) => {
		state.endItemofPage = payload;
	},
	setLastPosition: (state, payload) => {
		state.lastPosition = payload;
	},

	setNextPagination: (state, payload) => {
		state.pagination.length += payload.length;
		state.pagination.pageNumber++;
		state.pagination.offset = state.pagination.pageNumber * state.pagination.limit;
	},
	resetPagination: (state) => {
		state.pagination = pagination();
	},
	setNextPaginationMessage: (state, payload) => {
		state.paginationMessage.length += payload.length;
		state.paginationMessage.pageNumber++;
		state.paginationMessage.offset = state.paginationMessage.pageNumber * state.paginationMessage.limit;
	},
	resetPaginationMessage: (state) => {
		state.paginationMessage = paginationMessage();
	},
	setNextPaginationTemplate: (state, payload) => {
		state.paginationTemplate.length += payload.length;
		state.paginationTemplate.pageNumber++;
		state.paginationTemplate.offset = state.paginationTemplate.pageNumber * state.paginationTemplate.limit;
	},
	resetPaginationTemplate: (state) => {
		state.paginationTemplate = paginationTemplate();
	},

	toggleDisplayItem: (state, payload) => {
		let etIdx = state.displayItem.findIndex((item) => item.id === payload.data.id);
		if (etIdx === -1 && payload.mode === "add") {
			state.displayItem.push(payload.data);
		}

		if (etIdx !== -1 && payload.mode === "remove") {
			state.displayItem.splice(etIdx, 1);
		}
	},

	setListHistory: (state, payload) => {
		let data = []
		payload.array.forEach(v => {
			v.message_detail.progress = v.message_detail.sukses + v.message_detail.gagal
			data = data.concat(v)
		})
		state.listHistory = state.listHistory.concat(data);
		state.totalHistory = payload.count;
	},
	resetListHistory: (state) => {
		state.listHistory = [];
		state.totalHistory = 0;
	},
	setCountTemplate: (state, payload) => {
		state.countTemplate = payload;
	},
	resetCountTemplate: (state) => {
		state.countTemplate = 0
	},
	setWaDevice: (state, payload) => {
		state.waDevice = payload;
	},
	resetWaDevice: (state) => {
		state.waDevice = [];
	},
	setSelectedWaDevice: (state, payload) => {
		state.selectedWaDevice = payload
	},
	setIsSearch: (state, payload) => {
		state.isSearch = payload
	},
	setSearch: (state, payload) => {
		state.search = payload
	},
	setSearchLoading: (state, payload) => {
		state.searchLoading = payload
	},
	setListHistoryTemp: (state, payload) => {
		state.listHistoryTemp = payload.array
	},
	resetListHistoryTemp: (state) => {
		state.listHistoryTemp = []
	},
	setDetailHistory: (state, payload) => {
		payload.message_detail.progress = 0
		state.detailHistory = payload
	},
	setListMessage: (state, payload) => {
		state.listMessage = state.listMessage.concat(payload.array)
	},
	resetListMessage: (state) => {
		state.listMessage = []
	},
	setDetailTemplate: (state, payload) => {
		state.detailTemplate = payload
	},
	setListTemplate: (state, payload) => {
		state.listTemplate = state.listTemplate.concat(payload.array);
		state.totalTemplate = payload.count;
	},
	resetListTemplate: (state) => {
		state.listTemplate = [];
		state.totalTemplate = 0;
	},
	setPayloadCreateBlast: (state, payload) => {
		state.payloadCreateBlast = payload
	},
	resetPayloadCreateBlast: (state) => {
		state.payloadCreateBlast = payloadCreateBlast()
	},
	setListCustomer: (state, payload) => {
		state.listCustomer = payload.array
		state.totalCustomer = payload.count
	},
	resetListCustomer: (state) => {
		state.listCustomer = []
	},
	setBlastType: (state, payload) => {
		state.blastType = payload
	},
	setBlastTypeId: (state, payload) => {
		state.blastTypeId = payload
	},
};

export default mutations;